import { render, staticRenderFns } from "./ChangeLocale.vue?vue&type=template&id=241a2ebb"
import script from "./ChangeLocale.vue?vue&type=script&lang=js"
export * from "./ChangeLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports